// extracted by mini-css-extract-plugin
module.exports = {"container":"badge_container__pR_69","--cursor":"badge_--cursor__JR7Av","--bordered":"badge_--bordered___0i_5","--circle-prefix":"badge_--circle-prefix__Jq_0T"};